/* Opens and closes the shipping-country modal.
   The <dialog> element supplies focus trapping and Esc handling, so this only
   wires the triggers and the click-outside-to-dismiss behaviour. */

(function () {
  function dialogFor(trigger) {
    var suffix = trigger.getAttribute('data-country-modal-open');
    return document.getElementById('CountryModal-' + suffix);
  }

  document.addEventListener('click', function (event) {
    var trigger = event.target.closest('[data-country-modal-open]');
    if (trigger) {
      var dialog = dialogFor(trigger);
      if (dialog && typeof dialog.showModal === 'function') {
        event.preventDefault();
        dialog.showModal();
      }
      return;
    }

    var closer = event.target.closest('[data-country-modal-close]');
    if (closer) {
      var owner = closer.closest('dialog');
      if (owner) owner.close();
      return;
    }

    // Clicking the backdrop lands on the <dialog> itself, never on the panel.
    var openDialog = event.target.closest('dialog.country-modal');
    if (openDialog && !event.target.closest('.country-modal__panel')) {
      openDialog.close();
    }
  });
})();
